<onyx-modal
  variant="center"
  [heading]="`${I18N}.${data.mode}Unit`"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  <form [formGroup]="form" [onyxAutoFocus]="data.mode">
    @let controls = form.controls;
    <app-dictionaries-names-translation-form
      [form]="controls.names"
      label="labels.unitName"
      [initialValue]="data.mode === OnyxFormMode.ADD ? data.name : undefined"
    ></app-dictionaries-names-translation-form>

    @let sizeGroup = controls.size;
    <div class="form-group" [formGroup]="sizeGroup">
      @let sizeControls = sizeGroup.controls;
      <div class="radio">
        <p class="f-body-l">
          {{ `${I18N}.size` | translate }}
        </p>

        <div class="radio-buttons">
          @for (sizeType of sizeTypes$ | async; track sizeType.value) {
            <onyx-radio-button
              [formControl]="sizeControls.type"
              [label]="sizeType.name"
              [option]="sizeType.value"
            ></onyx-radio-button>
          }
        </div>
      </div>

      @switch (type()) {
        @case (GoodsSizeType.LOADING_METERS) {
          <div class="group">
            <onyx-form-group [controls]="sizeControls.loadingMeters">
              <onyx-text-field
                [formControl]="sizeControls.loadingMeters"
                [warning]="
                  sizeControls.loadingMeters.value
                    | unitWarning: 'loadingMeters'
                "
                label="labels.loadingMeters"
                [decimalPlaces]="2"
                unit="LDM"
                [showErrors]="false"
              ></onyx-text-field>
            </onyx-form-group>

            <onyx-toggle
              [formControl]="sizeControls.requiresCoilWell"
              label="labels.coilWell"
            ></onyx-toggle>
          </div>
        }
        @case (GoodsSizeType.DIMENSIONS) {
          <div class="group">
            <onyx-form-group [controls]="sizeControls.length">
              <onyx-text-field
                [formControl]="sizeControls.length"
                [warning]="
                  sizeControls.length.value | unitWarning: 'cargoLength'
                "
                label="labels.length"
                [decimalPlaces]="2"
                unit="m"
                [showErrors]="false"
              ></onyx-text-field>

              <onyx-suggestions
                [control]="sizeControls.length"
                [suggestions]="
                  sizeControls.length.value | unitSuggestions: 'cargoLength'
                "
              ></onyx-suggestions>
            </onyx-form-group>

            <onyx-form-group [controls]="sizeControls.width">
              <onyx-text-field
                [formControl]="sizeControls.width"
                [warning]="sizeControls.width.value | unitWarning: 'cargoWidth'"
                label="labels.width"
                [decimalPlaces]="2"
                unit="m"
                [showErrors]="false"
              ></onyx-text-field>

              <onyx-suggestions
                [control]="sizeControls.width"
                [suggestions]="
                  sizeControls.width.value | unitSuggestions: 'cargoWidth'
                "
              ></onyx-suggestions>
            </onyx-form-group>

            <onyx-form-group [controls]="sizeControls.height">
              <onyx-text-field
                [formControl]="sizeControls.height"
                [warning]="
                  sizeControls.height.value | unitWarning: 'cargoHeight'
                "
                label="labels.height"
                [decimalPlaces]="2"
                unit="m"
                [showErrors]="false"
              ></onyx-text-field>

              <onyx-suggestions
                [control]="sizeControls.height"
                [suggestions]="
                  sizeControls.height.value | unitSuggestions: 'cargoHeight'
                "
              ></onyx-suggestions>
            </onyx-form-group>
          </div>
        }
        @case (GoodsSizeType.VOLUME) {
          <div class="group">
            <onyx-form-group [controls]="sizeControls.volume">
              <onyx-text-field
                [formControl]="sizeControls.volume"
                [warning]="sizeControls.volume.value | unitWarning: 'volume'"
                label="labels.volume"
                [decimalPlaces]="3"
                unit="m³"
                [showErrors]="false"
              ></onyx-text-field>
            </onyx-form-group>
          </div>
        }
      }
    </div>
  </form>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button [spinner]="loading()" (click)="!loading() ? submit() : null">
      {{
        `labels.${data.mode === OnyxFormMode.ADD ? 'add' : 'saveChanges'}`
          | translate
      }}
    </onyx-button>
  </ng-container>
</onyx-modal>
